// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Icon from "../images-and-icons/Icon.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "./Button.res.js";
import * as Tooltip from "../overlays/Tooltip.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as ReactAria from "react-aria";
import * as JsxRuntime from "react/jsx-runtime";

function use(value, disabledOpt) {
  let disabled = disabledOpt !== undefined ? disabledOpt : false;
  let match = React.useState(() => false);
  let setCopied = match[1];
  let copied = match[0];
  React.useEffect(() => {
    if (!copied) {
      return;
    }
    let timer = setTimeout(() => setCopied(param => false), 1500);
    return () => {
      clearTimeout(timer);
    };
  }, [copied]);
  let match$1 = ReactAria.useClipboard({
    getItems: param => [{
        "text/plain": value
      }],
    isDisabled: disabled,
    onCopy: () => setCopied(param => true)
  });
  let copy = () => {
    window.navigator.clipboard.writeText(value);
    setCopied(param => true);
  };
  return {
    copied: copied,
    copy: copy,
    icon: copied ? "tick" : "duplicate_v1",
    tooltipText: copied ? I18n.t("Copied to clipboard!") : I18n.t("Copy"),
    ariaProps: ReactAria.mergeProps(match$1.clipboardProps, {
      "aria-label": "copy"
    })
  };
}

function CopyButton(props) {
  let disabled = props.disabled;
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  let match = use(props.value, disabled);
  let copied = match.copied;
  return JsxRuntime.jsx(Button.make, {
    ariaProps: match.ariaProps,
    variant: props.variant,
    tone: props.tone,
    size: size,
    bold: copied,
    active: copied,
    disabled: disabled,
    inert: copied,
    icon: match.icon,
    iconSize: 15,
    tooltipText: match.tooltipText,
    stylex: props.stylex,
    onPress: match.copy
  });
}

function CopyButton$Compact(props) {
  let spaceLeft = props.spaceLeft;
  let __size = props.size;
  let size = __size !== undefined ? __size : 13;
  let match = use(props.value, undefined);
  let copy = match.copy;
  let copied = match.copied;
  let match$1 = Hover.use(undefined, undefined, undefined);
  let inertProps = copied ? ({
      inert: "true"
    }) : undefined;
  let newrecord = {...inertProps};
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsxs(Touchable.make, {
      children: [
        spaceLeft !== undefined ? JsxRuntime.jsx(Box.make, {
            spaceLeft: spaceLeft
          }) : null,
        JsxRuntime.jsx(Icon.make, {
          name: match.icon,
          fill: copied || match$1[1] ? "#25243A" : "#767589",
          width: size,
          height: size,
          bold: copied
        })
      ],
      ariaProps: match.ariaProps,
      disabled: copied,
      wrap: false,
      onPress: param => copy(),
      ref: match$1[0]
    }), newrecord)),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: match.tooltipText
    }),
    delay: copied ? 0 : 350,
    closeDelay: 0
  });
}

let Compact = {
  make: CopyButton$Compact
};

let resetDelay = 1500;

let make = CopyButton;

export {
  resetDelay,
  use,
  make,
  Compact,
}
/* Box Not a pure module */
